import { useMediaQuery } from "@mui/material";
import React, { createContext, useState } from "react";

export const ApplicationContext = createContext();
let path = [
  "dashboard",
  "employee-onboarding",
  "licence",
  "user-profile",
  "company-profile",
  "representative-profile",
];
let location = window.location.pathname.split("/")[2];
console.log(location, "locc");
export const ApplicationContextProvider = (props) => {
  const [login, setLogin] = useState(true);
  const [OTP, setOTP] = useState("");
  const [reloadProfile, setReloadProfile] = useState(false);
  const [tokenTemp, setTokenTemp] = useState("");
  const [globalLoader, setGlobalLoader] = useState(false);
  const [clientSecret, setClientSecret] = useState(
    "pi_3Ok3abSGFIOP7bSa0JqDBQNv_secret_psj8gfOgxwbNiiUNeyMo87NOV"
  );
  const [tableView, setTableView] = useState(0);
  const [header, setHeader] = useState("");
  const [licenceType, setLicenceType] = useState("");
  const [confirmPurchase, setConfirmPurchase] = useState(false);
  const [standardPlanPrice, setStandardPlanPrice] = useState(null);
  // user detail
  const [profileDetails, setProfileDetails] = useState({});
  const [adminProfileDetail, setAdminProfileDetail] = useState(null);

  const [selectedNoOfEmployees, setSelectedNoOfEmployees] = useState("1");
  const [expiryDialog, setExpiryDialog] = useState(false);

  // media query
  const dashboardQuery = useMediaQuery("(max-width:1145px)");
  const [activeTab, setActiveTab] = useState(path?.indexOf(location));
  const [dockMenu, setDockMenu] = useState(false);

  // snackbar
  const [profileSnack, setProfileSnack] = useState(false);
  const [error, setError] = useState("");

  // subscription
  const [subDialog, setSubDialog] = useState(false);
  const [subscriptionNav, setSubscriptionNav] = useState(false);

  const [globalSnackBar, setGlobalSnackBar] = useState(null);

  // dialog
  const [isOpenRegisterEmployeeDialog, setIsOpenRegisterEmployeeDialog] =
    useState(false);
  const [isOpenEditEmployeeDialog, setIsOpenEditEmployeeDialog] =
    useState(false);
  const [isOpenDeleteEmployeeDialog, setIsOpenDeleteEmployeeDialog] =
    useState(false);
  const [isOpenUploadEmployeeDialog, setIsOpenUploadEmployeeDialog] =
    useState(false);

  const [isOpenWelcomeDialog, setIsOpenWelcomeDialog] = useState(false); // it should only show after first time login to user

  // onboarding
  const [addRowEmp, setAddRowEmp] = useState([
    // {
    //   epId: "cc",
    //   epName: null,
    //   epEmail: null,
    //   epDesignation: null,
    //   licenseStatus: "unallocated",
    // },
    {
      epId: "2839DD4",
      epName: "Antony",
      epEmail: "antony@gmail.com",
      epDesignation: "Director",
      licenseStatus: "allocated",
    },
    {
      epId: "2839FD4",
      epName: "Tony",
      epEmail: "tony@gmail.com",
      epDesignation: "Director",
      licenseStatus: "unallocated",
    },
    {
      epId: "2849DD4",
      epName: "Howard",
      epEmail: "howard@gmail.com",
      epDesignation: "Admin",
      licenseStatus: "allocated",
    },
    {
      epId: "4859DD4",
      epName: "Nick",
      epEmail: "nick@gmail.com",
      epDesignation: "Employee",
      licenseStatus: "unallocated",
    },
  ]);

  const [employeesList, setEmployeesList] = useState([
    {
      empName: "ankit Kumar",
      empEmail: "ankit.kumar@gmail.com",
      empDesignation: "UX Designer",
      licenceStatus: "active",
      licenceType: "Standard",
    },
    {
      empName: "rahul Kumar",
      empEmail: "rahul.kumar@gmail.com",
      empDesignation: "UI Designer",
      licenceStatus: "expired",
      licenceType: "Trial",
    },
    {
      empName: "ankut Kumar",
      empEmail: "ankur.kumar@gmail.com",
      empDesignation: "UX Designer",
      licenceStatus: "active",
      licenceType: "Standard",
    },
    {
      empName: "akhilesh Kumar",
      empEmail: "ankur.kumar@gmail.com",
      empDesignation: "UX Designer",
      licenceStatus: "active",
      licenceType: "Standard",
    },
    {
      empName: "jordan Kumar",
      empEmail: "ankur.kumar@gmail.com",
      empDesignation: "UX Designer",
      licenceStatus: "active",
      licenceType: "Trial",
    },
    {
      empName: "monwas Kumar",
      empEmail: "ankur.kumar@gmail.com",
      empDesignation: "UX Designer",
      licenceStatus: "active",
      licenceType: "Standard",
    },
  ]);
  const [filteredList, setFilteredList] = useState([
    {
      empName: "ankit Kumar",
      empEmail: "ankit.kumar@gmail.com",
      empDesignation: "UX Designer",
      licenceStatus: "active",
      licenceType: "Standard",
    },
    {
      empName: "rahul Kumar",
      empEmail: "rahul.kumar@gmail.com",
      empDesignation: "UI Designer",
      licenceStatus: "expired",
      licenceType: "Trial",
    },
    {
      empName: "ankut Kumar",
      empEmail: "ankur.kumar@gmail.com",
      empDesignation: "UX Designer",
      licenceStatus: "active",
      licenceType: "Standard",
    },
    {
      empName: "akhilesh Kumar",
      empEmail: "ankur.kumar@gmail.com",
      empDesignation: "UX Designer",
      licenceStatus: "active",
      licenceType: "Standard",
    },
    {
      empName: "jordan Kumar",
      empEmail: "ankur.kumar@gmail.com",
      empDesignation: "UX Designer",
      licenceStatus: "active",
      licenceType: "Trial",
    },
    {
      empName: "monwas Kumar",
      empEmail: "ankur.kumar@gmail.com",
      empDesignation: "UX Designer",
      licenceStatus: "active",
      licenceType: "Standard",
    },
  ]);
  const [licenceBatchList, setLicenceBatchList] = useState([]);
  const [auditList, setAuditList] = useState([]);
  const [paymentList, setPaymentList] = useState([]);
  const [assignDetails, setAssignDetails] = useState("");
  const [organisationList, setOrganisationList] = useState([]);
  const [referalList, setReferalList] = useState([]);
  const [filterOrgList, setFilterOrgList] = useState([]);
  const [adminList, setAdminList] = useState([]);

  const [registerDetails, setRegisterDetails] = useState({
    epId: null,
    epName: null,
    epEmail: null,
    epDesignation: null,
    licenseStatus: "unallocated",
  });

  let values = {
    login,
    setLogin,

    expiryDialog,
    setExpiryDialog,

    standardPlanPrice,
    setStandardPlanPrice,

    /* Verification otp */
    OTP,
    setOTP,

    /* Profile reload states */
    reloadProfile,
    setReloadProfile,

    adminProfileDetail,
    setAdminProfileDetail,

    globalSnackBar,
    setGlobalSnackBar,

    auditList,
    setAuditList,
    confirmPurchase,
    setConfirmPurchase,
    paymentList,
    setPaymentList,

    referalList,
    setReferalList,

    header,
    setHeader,

    dockMenu,
    setDockMenu,

    licenceBatchList,
    setLicenceBatchList,
    filteredList,
    setFilteredList,

    assignDetails,
    setAssignDetails,

    organisationList,
    setOrganisationList,

    filterOrgList,
    setFilterOrgList,

    adminList,
    setAdminList,

    tableView,
    setTableView,

    licenceType,
    setLicenceType,

    selectedNoOfEmployees,
    setSelectedNoOfEmployees,
    /* Jwt Token */
    tokenTemp,
    setTokenTemp,

    /* Stripe client secret */
    clientSecret,
    setClientSecret,

    profileDetails,
    setProfileDetails,

    globalLoader,
    setGlobalLoader,

    dashboardQuery,

    activeTab,
    setActiveTab,

    profileSnack,
    setProfileSnack,

    error,
    setError,

    subDialog,
    setSubDialog,

    subscriptionNav,
    setSubscriptionNav,

    isOpenRegisterEmployeeDialog,
    setIsOpenRegisterEmployeeDialog,

    isOpenEditEmployeeDialog,
    setIsOpenEditEmployeeDialog,

    isOpenDeleteEmployeeDialog,
    setIsOpenDeleteEmployeeDialog,

    isOpenUploadEmployeeDialog,
    setIsOpenUploadEmployeeDialog,

    isOpenWelcomeDialog,
    setIsOpenWelcomeDialog,

    addRowEmp,
    setAddRowEmp,

    employeesList,
    setEmployeesList,

    registerDetails,
    setRegisterDetails,
  };
  return (
    <ApplicationContext.Provider value={values}>
      {props.children}
    </ApplicationContext.Provider>
  );
};
